import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import { Alert, confirm } from "modules/theme";
import APIManager from "modules/common/apiManager";
import { Badge } from "react-bootstrap";
import { CenterFlexRow, BackButton } from "../../styles";
import NlpIntentAddEdit from "./NlpIntentAddEdit";
import { FiTrash2 } from "react-icons/fi";
import { PerPage } from "helpers/system-config";
import { Dropdown, MenuItem } from "react-bootstrap";
import { HiDotsVertical } from "react-icons/hi";
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Label,
  Tip,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  SeachForm,
  ImportFile,
  DataWrapperClass,
  DropdownToggle,
  ButtonCommonTheme,
  Icon,
  SettingDropdownMenu,
} from "modules/theme";
import { leftSidebarType, modalType } from "../../../../../helpers/dotenv";
import { MdOutlineAdd } from "react-icons/md";
import { OverflowClass } from "modules/theme";

class NlpIntent extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = `NLP Intent`;
    // this.handleModalShowHide = this.handleModalShowHide.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModalShow = this.closeModalShow.bind(this);
    // this.openModalShow = this.openModalShow.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.clearSearchField = this.clearSearchField.bind(this);
    this.state = {
      agentId: props.agentId || "",
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      infoData: null,
      showHide: false,
      modalType: modalType,
      search: "",
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      show: false,
      searchValue: "",
    };
  }

  handleModal() {
    this.setState({ show: !this.state.show });
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  clearSearchField() {
    this.setState({ searchValue: "" });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    // const ary = [];
    const list = this.state.SelectedList.map((data) => {
      // ary = data._id;
      this.state.ary.push(data._id);
      // this.setState({ ary: data._id });
      console.log("data", this.state.ary);
    });
    this.mAPI.sendPostAPI(
      `setting/nlp-intent/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        console.log(JSON.stringify(data, null, 2));
        this.getList(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.contactId
        );
        Alert.success(`${this.moduleName} is deleted.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  search(e) {
    const value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (value.trim() || value === "") {
        let teamList = this.state.listData.map((item) => ({
          item,
          selected: false,
        }));
        this.setState({
          SelectedList: [],
          MasterChecked: false,
          SingleChecked: false,
          listData: teamList,
          searchValue: value,
          currentPage: 1,
        });
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.setState({ search: value });
          this.getList(1, this.state.perPageCount, value);
        }, 500);
      }
    }
  }

  componentDidMount() {
    this.getList(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.contactId
    );
  }

  // handleModalShowHide() {
  //   this.setState({ showHide: !this.state.showHide });
  // }

  getList(page = 1, perPage = "", searchText = "") {
    var that = this;
    let agentId = this.state.agentId || "";
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `setting/nlp-intent/${agentId}?limit=${perPage}&page_no=${page}&orderBy=create_at&order=DESC&search=${searchText}`,
      (data) => {
        this.setState({ loading: false });
        console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({
            listData: data.data,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
          });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }

  onPaginationChange(page) {
    console.log("onPaginationChange", page);
    this.setState({ currentPage: page });
    this.getList(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    console.log("onPerPageChooser", perPage);
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getList(1, perPage, this.state.search);
  }

  closeModalShow() {
    this.setState({ show: false });
  }
  openModalShow(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({
        showHide: true,
        infoData: undefined,
        editData: undefined,
      });
    }
    // this.setState({ show: true });
  }

  closeModal(isUpdated) {
    console.log("isUpdated", isUpdated);
    this.setState({ showHide: false });
    if (isUpdated === true) {
      this.getList(
        this.state.currentPage,
        this.state.perPageCount,
        this.state.search
      );
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  delete(tData) {
    var that = this;
    this.mAPI.sendPostAPI(
      `setting/nlp-intent/${tData._id}`,
      undefined,
      (data) => {
        console.log(JSON.stringify(data, null, 2));
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", tData._id);
        that.setState({ listData: tD });
        that.getList(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.contactId
        );
        Alert.success(`The ${tData.name} is deleted.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  onChange() {}

  onSingleChange(e, company) {}

  edit(tData) {
    return (
      <ButtonCommonTheme
        type="edit"
        editOnClick={() => this.openModal(tData)}
      />
    );
  }

  getIDDetails(tData) {
    var that = this;
    this.setState({ loading: true });
    this.mAPI.sendGetAPI(
      `setting/nlp-intent/${tData}`,
      (data) => {
        this.setState({ loading: false });
        console.log(JSON.stringify(data, null, 2));
        if (data) {
          console.log("Dataaaa", data);
          // that.setState({ listData: data.data, total: data.count || 0 });
        } else {
          // that.setState({ listData: [] });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }

  renderActions(tData) {
    const { __ } = this.context;
    return (
      <ActionButtons>
        {this.edit(tData)}
        <Dropdown id="dropdown-engage" pullRight style={{}}>
          <DropdownToggle bsRole="toggle">
            <Button btnStyle="link" size="medium">
              <HiDotsVertical style={{ fontSize: "17px" }} />
            </Button>
          </DropdownToggle>
          <Dropdown.Menu>
            <MenuItem style={{ marginLeft: "0px" }}>
              <a
                onClick={(e) =>
                  confirm().then((e) => {
                    this.delete(tData, e);
                  })
                }
              >
                {"Delete"}
              </a>
            </MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </ActionButtons>
    );
  }

  importContact(file) {
    let formData = new FormData();
    formData.append("file", file);
    // formData.append('contactListId', this.state.contactId);
    return formData;
  }

  renderActionBar() {
    let _this = this;
    const ImportTrigger = ({ onClick }) => {
      console.log("typeProps", onClick);
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <ButtonCommonTheme type="iconPrimaryBtn" addOnClick={() => {}} />
        <ModalTrigger
          title={this.moduleName}
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          openModalShow={this.openModalShow}
          dialogClassName={this.state.modalType}
        >
          <NlpIntentAddEdit
            update={() => this.setState({ currentPage: 1 })}
            size="small"
            isEdit={false}
            agentId={this.state.agentId}
            editData={this.state.editData}
            infoData={this.state.infoData}
            closeModal={this.closeModal}
            modalType={this.state.modalType}
            clearSearchField={this.clearSearchField}
          />
        </ModalTrigger>

        {/* <ImportFile
          apiUrl={`setting/sip/report/import`}
          fetchData={this.importContact}
          importDone={() => {

            console.log("done");
            _this.setState({ loading: true });
            setTimeout(() => {
              _this.onPerPageChooser(_this.state.perPageCount)
            }, 3000)
          }}
          urlDownload={`sip.csv`}
        ></ImportFile> */}
      </span>
    );
  }

  renderUtterances(utterances) {
    if (!utterances || !utterances.length) {
      return <React.Fragment />;
    }
    let list = [];
    let counter = 1;
    for (const iterator of utterances) {
      if (counter > 2) {
        list.push(<Badge bg="secondary">{utterances.length - 2}+</Badge>);
        break;
      }
      let userSays = iterator.userSays || "";
      list.push(<Badge bg="secondary">{iterator.userSays}</Badge>);
      counter++;
    }
    return list;
  }
  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Message Setting"), link: "/message" },
      { title: __("NLP Intent"), link: `/nlp/intent/${this.state.agentId}` },
    ];

    const mainContent = (
      <DataWrapperClass>
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th>{__("name")}</th>
              <th>{__("example utterances")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody id="list">
            {this.state.listData &&
              this.state.listData.map((tData) => (
                <tr key={tData._id}>
                  <td className="">{tData.intentName}</td>
                  <td>{this.renderUtterances(tData.examples)}</td>
                  <td>{this.renderActions(tData)}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={
              <CenterFlexRow className="header-label">
                <Link className="btn-back" to={`/settings`}>
                  <BackButton>
                    <Icon icon="angle-left" size={20} />
                  </BackButton>
                </Link>
                <ControlLabel>{this.moduleName}</ControlLabel>
              </CenterFlexRow>
            }
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    {/* <ControlLabel>{`SIP Extensions (${this.state.total || 0})`}</ControlLabel> */}
                    <SeachForm className="mr-5">
                      <FormControl
                        type="text"
                        placeholder={"Search..."}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                    </SeachForm>
                    {this.state.SelectedList.length > 0 ? (
                      // <ButtonCommonTheme type="deleteAll" checkboxDeleteOnClick={e =>
                      //   confirm().then(e => {
                      //     this.deleteAllData(e);
                      //   })
                      // } />
                      /* <button
                        onClick={(e) => {
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          });
                        }}
                      >
                        deleteall
                      </button> */
                      <ButtonCommonTheme
                        type="deleteAll"
                        checkboxDeleteOnClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    ) : (
                      // <Tip text={`${'Delete'}`} key={`${'Delete'}`}>
                      //   <Button
                      //     btnStyle="danger"
                      //     size="small"
                      //     onClick={e =>
                      //       confirm().then(e => {
                      //         this.deleteAllData(e);
                      //       })
                      //     }
                      //     style={{
                      //       verticalAlign: 'middle',
                      //       marginLeft: '10px'
                      //     }}
                      //   // icon={'user-minus'}
                      //   >
                      //     <FiTrash2
                      //       style={{ fontSize: '14px', marginBottom: '-3px' }}
                      //     />
                      //   </Button>
                      // </Tip>
                      ""
                    )}
                  </div>
                }
                // right={actionBarRight}
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText=""
                  emptyImage="/images/emptySIP.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

NlpIntent.contextTypes = {
  __: PropTypes.func,
};

export default NlpIntent;



// WEBPACK FOOTER //
// src/modules/screens/settings/NlpIntenet/components/NlpIntent.js